export type SteveCategoryDTO = {
	id: string;
	name: string;
	children?: SteveCategoryDTO[];
};

export class SteveCategory {
	public readonly id: string;
	public readonly name: string;
	public readonly children: SteveCategory[];

	constructor(category: SteveCategoryDTO) {
		this.id = category.id;
		this.name = category.name;
		this.children = !!category.children ? category.children.map(child => new SteveCategory(child)) : [];
	}
}
